import React from "react";
import styled from "styled-components"
import { breakPoint, rem } from "../styleUtils";

type Props = {
    bleed: "left"|"right"|"none"
    verticalAlignment: "start"|"end"|"center"|"start-no-padding"|"end-no-padding"|"center-no-padding"
}
export const ContentWrapper = styled.div<Props>`
    width: 100%;
    display: flex;
    
    padding: ${rem(32 + 24)} 0px;
    @media only screen and (max-width : 768px) {
        padding: ${rem(32 + 24)} 0px;
    }

    ${(props) => {
        switch (props.bleed) {
            case "left":
                return `
                    justify-content: end;
                `
            case "right":
                return `
                    justify-content: start;
                `
            case "none":
                return `
                    justify-content: center;
                    & ${Content} {
                        max-width: 100%;
                    }
                    
                `
        }
    }}

    ${(props) => {
        switch (props.verticalAlignment) {
            case "start":
                return `
                    align-self: start;
                `
            case "end":
                return `
                    align-self: end;
                `
            case "center":
                return `
                    align-self: center;
                `
            case "start-no-padding":
                return `
                    align-self: start;
                    padding-top: 0;
                    @media only screen and (max-width : 768px) {
                        padding-top: 0;
                    }
                `
            case "end-no-padding":
                return `
                    align-self: end;
                    padding-bottom: 0;
                    @media only screen and (max-width : 768px) {
                        padding-bottom: 0;
                    }
                `
            case "center-no-padding":
                return `
                    align-self: center;
                    padding-bottom: 0;
                    padding-top: 0;
                    @media only screen and (max-width : 768px) {
                        padding-bottom: 0;
                        padding-top: 0;
                    }
                `
        }
    }};

    
`




type ContentProps = {
    fullWidth: boolean
}
export const Content = styled.div<ContentProps>`
    width: ${props => props.fullWidth ? "100%" : "auto"};
`

export default function BlockContent ({
    children,
    bleed,
    fullWidth = false,
    verticalAlignment = "center"
}: {
    children: JSX.Element|JSX.Element[]
    bleed: "left"|"right"|"none",
    fullWidth?: boolean
    verticalAlignment?: "start"|"end"|"center"|"start-no-padding"|"end-no-padding"|"center-no-padding"
}) {
    return (
        <ContentWrapper bleed={bleed} verticalAlignment={verticalAlignment}>
            <Content fullWidth={fullWidth}>
                {children}
            </Content>
        </ContentWrapper>
    )
}